module.exports = __webpack_public_path__ + "img/glyphicons-halflings-regular.eot?f4769f9bdb7466be65088239c12046d1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/bootstrapv3/fonts/glyphicons-halflings-regular.eot
// module id = 253
// module chunks = 0